export default __webpack_public_path__ + "static/media/Icon menu Attendance _ Active.24e67600.svg";